export const ROLE_TYPES = [
  "AM", "BP", "BMG", "CM", "DEV-B", "DM", "MED", "PM", "PR", "QA", "SEO", "TRAFF", "UX",
];
// "Top Manager" intentionally excluded — it's a blanket-access role granted
// server-side, never a selectable share target.
